import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

import type { ReservationType } from 'src/features/reservations/types/reservationType';

const RESOURCE = '/reservations/:parkingId/vehicle-stay-reservation-type/:versionId/';

interface DTO {
    parkingId: string;
    versionId: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, versionId, ...data }: DTO): Promise<ReservationType> => {
    return axios.patch(formatResourcePath(RESOURCE, { parkingId, versionId }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateReservationType };
